export const GET_JOB_PROFILE_REQUEST = 'GET_JOB_PROFILE_REQUEST';
export const GET_JOB_PROFILE_SUCCESS = 'GET_JOB_PROFILE_SUCCESS';
export const GET_JOB_PROFILE_FAILURE = 'GET_JOB_PROFILE_FAILURE';

export const GO_TO_NEXT_REQUEST = 'GO_TO_NEXT_REQUEST';
export const GO_TO_PREV_REQUEST = 'GO_TO_PREV_REQUEST';

export const GET_SPECIALIZATION_REQUEST = 'GET_SPECIALIZATION_REQUEST';
export const GET_SPECIALIZATION_SUCCESS = 'GET_SPECIALIZATION_SUCCESS';
export const GET_SPECIALIZATION_FAILURE = 'GET_SPECIALIZATION_FAILURE';